A physical address.
